<template>
    <div>
        <RoundIcon :icon="icon" />
        <p>{{description}}</p>
    </div>
</template>

<script>
import RoundIcon from "@/patterns/RoundIcon.vue";
export default {
  name: "FeatureListItem",  
  components: { RoundIcon },
  data: () => ({}),
  props: { icon:String, description:String },
};
</script>


<style lang="scss" scoped>
p {
    color:#fff;
    text-transform: uppercase;
    font-weight: 900;
    display:inline-block;
    margin:0;
    margin-left:20px;
}
div {
    display:flex;
    align-items: center;
    margin-bottom:12px;
    &:last-child {
        margin-bottom: 0;
    }
    .icon {
        flex-shrink: 0;
        flex-grow: 0;
    }
    p {
        flex-grow:1
    } 
}
</style>
